import '@mdi/font/css/materialdesignicons.css'
import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import '@fortawesome/fontawesome-free/css/all.css'

Vue.use(Vuetify)

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#9c27b0',
        secondary: '#4caf50',
        tertiary: '#495057',
        // accent: '#82B1FF',
        accent: '#9c27b0',
        error: '#f55a4e',
        info: '#00d3ee',
        success: '#5cb860',
        warning: '#ffa21a',
      },
    },
  },
  icons: [
    {
      iconfont: 'mdi',
    }, 
    {
      iconfont: 'fa',
    },
    {
      iconfont: 'md',
    },
  ],
})
